export class AppConstants {
   public static SupportURL: string = "https://certiport.pearsonvue.com/Support.aspx";
}
